import React, { useEffect, useRef, useState } from "react";
import styles from "./switch.module.css";

// `dimmed` atenúa el interruptor (usuario de solo lectura) sin envolverlo en
// otro elemento: el contenedor tiene que seguir siendo hijo directo de la fila
// flex de la salida para estirarse a su altura y quedar centrado.
export default function Switch({ value, onChange, id, dimmed = false, title }) {
  const [localValue, setLocalValue] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [firstUpdate, setFirstUpdate] = useState(true);
  const expectedValue = useRef(null);

  useEffect(() => {
    if (firstUpdate) {
      setFirstUpdate(false);
      return;
    }
    if (localValue === null) setLocalValue(value);
    if (loading && value === expectedValue.current) {
      setLoading(false);
    } else if (!loading) {
      setLocalValue(value);
    }
  }, [value]);

  const handleClick = (event) => {
    if (loading) return;
    setLoading(true);
    event.stopPropagation();
    const oldActive = localValue;
    const newValue = !oldActive;
    expectedValue.current = newValue;
    setLocalValue(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <div className={styles.container} style={dimmed ? { opacity: 0.45 } : undefined} title={title}>
      <div className={"d-flex justify-content-center"}>
        <div
          className={`${styles.switch} ${!localValue ? styles.inactive : ""} ${
            loading ? styles.loading : ""
          }`}
          onClick={handleClick}
        >
          <div className={styles.toggle}>
            {loading && <div className={styles.spinner} />}
          </div>
        </div>
      </div>

      <div>
        <div
          style={{
            color: localValue ? "#429C23" : "#C7C7C7",
            fontWeight: 600,
          }}
        >
          {localValue ? "ON" : "OFF"}
        </div>
      </div>
    </div>
  );
}
